// @flow
import React from 'react';
// import { Link } from 'react-router';

import { DotsLoader } from 'app/common/components/Loader';
// import IconSettings from 'app/components/_Icons/IconSettings';
import Tooltip from 'app/common/ui/Tooltip';
import { useCurrencySign } from 'app/common/components-next/currency';

import Avatar from 'app/common/ui/Avatar';
import enhanceHeader from './enhanceHeader';
import styles from './Header.scss';


type Props = {
  id: string,
  lc: string,
  name: string,
  photo?: string,
  from: string,
  gender: string,
  status: string,
  shadow: boolean,
  loading: boolean,
  balance: string,
  balanceCamp: string,
  hasCafeteria: boolean,
  isToday: boolean,
  isStudent: boolean,
  isGlolime: boolean,
  shadowClassName: string,
  externalSystemSync: boolean,
}

const Header = ({
  id,
  lc,
  name,
  photo,
  from,
  gender,
  status,
  // shadow,
  balance,
  balanceCamp,
  loading,
  hasCafeteria,
  isToday,
  isStudent,
  isGlolime,
  shadowClassName,
  externalSystemSync,
}: Props) => {
  const currency = useCurrencySign();

  return (
    <div className={styles.root}>
      <div className={shadowClassName}>
        <div className={styles.content}>
          <div className={styles.avaBlock}>
            {<Avatar src={photo} gender={gender} className={styles.ava} />}
          </div>
          <div className={styles.headers}>
            <div className={styles.title}>
              <h1 className={styles.h1}>{name}</h1>
              {/* Настройки временно отключены */}
              {/* {!isStudent
                && !externalSystemSync
                && <Link to={`/settings/${id}`} className={styles.settings}>
                  <IconSettings />
                </Link>} */}
            </div>
            <div className={styles.h2}>
              <Tooltip text={from}>
                <div className={styles.over}>{from}</div>
              </Tooltip>
              {isToday
                && !isGlolime
                && <div className={styles.balance}>
                  {balance}
                  {balance && currency}
                  {hasCafeteria
                    && loading
                    && <DotsLoader className={styles.loader} />}
                </div>}

                {balanceCamp
                  && <div className={styles.balance}>
                    {balanceCamp}
                    {balanceCamp && currency}
                  </div>}
              <div className={styles.lc}>
                {lc}
              </div>
            </div>
          </div>
          <div className={styles.status}>{status}</div>
        </div>
      </div>
    </div>
  );
};

export default enhanceHeader(Header);
